export const storage = {
    DP_CURBSIDE_CHECKIN_INFO: 'DP_CURBSIDE_CHECKIN_INFO',
    DP_CURBSIDE_PRODUCT_INFO: 'DP_CURBSIDE_PRODUCT_INFO',
};

export const nSSRReturnStatus = {
    Completed: 'Complete',
    InProgress: 'in Progress',
    Cancelled: 'Canceled',
};

export const nSSRDateStatus = {
    Completed: 'Completed',
    InProgress: 'Started',
    Cancelled: 'Canceled',
};

export const returnReasons = [
    { key: 'select', value: 'Select a reason ...' },
    { key: 'RETURN_DPD_WRONG_SIZE', value: 'Sizing Issues' },
    { key: 'RETURN_CM_QUALITY', value: 'Not What I Was Expecting' },
    { key: 'RETURN_DELIVERED_PRODUCT_DIFFERENT', value: 'Incorrect Item' },
    { key: 'RETURN_DEFECTIVE_ITEM', value: 'Defective' },
    { key: 'RETURN_CM_DONT_WANT', value: "Don't Want The Product Anymore" },
    { key: 'RETURN_OTHER', value: 'Other' },
];

export const INCIDENT_REASONS = [
    { "key": "select", "value": "Select an issue ..." },
    { "key": "1", "value": "Item not received" },
    { "key": "2", "value": "Item not as ordered" },
    { "key": "3", "value": "Defective item" },
    { "key": "5", "value": "Counterfeit item" },
    { "key": "6", "value": "Delivery took longer than expected" },
    { "key": "20", "value": "Question about delivery" },
    { "key": "21", "value": "Cancel the order" },
    { "key": "22", "value": "Issue with the item received" },
    { "key": "25", "value": "Information on the product" },
    { "key": "26", "value": "Other question" },
    { "key": "27", "value": "I didn't receive my return shipping label" }
];

export const RETURN_REVIEW_STEPS = [
    'Box your item and attach the provided prepaid shipping label. Drop it off at a courier location.',
];

export const RETURN_CONFIRMATION_STEPS = [
    'Print the prepaid return shipping label included in your return confirmation email. Please expect an email within 1 to 2 business days.',
    'Follow the return instructions and ship your return to the carrier indicated on the shipping label.',
    'After the item is received and inspected, your refund will be processed.',
];

export const INCIDENT_CONFIRMATION_STEPS = [
    'Your request has been submitted successfully. You will receive an email confirmation from our team.',
    'Depending on the issue, you may also receive a follow-up communication directly from the third-party seller.',
    'You should expect a response within 48 hours.',
];

export const RETURN_REVIEW_METHOD = 'Return Method';

export const RETURN_REVIEW_METHOD_DESCRIPTION = 'Return via Prepaid Shipping Label';

export const RETURN_ESTIMATE =
    'This is an estimate. Actual refund amount is subject to applied discounts, tax, shipping costs, and item condition.';

export const RETURN_NOT_ELIGIBLE = 'These items are no longer eligible for return.';

export const RETURN_WINDOW_TEXT =
    'These items are past the 30-day return policy and no longer eligible for return.';

export const RETURN_IN_STORE_TEXT = 'Items are not eligible for in-store returns.';

export const orderStatusTypes = {
    CANCEL: 'cancelled',
    PAYMENTDECLINED: 'declined',
};

export const INCIDENT_DUPLICATE_ERROR = 'This issue has already been reported.';
export const INCIDENT_GENERIC_ERROR =
    'We were unable to submit your request. Please try again later.';

/* Return method selection screen (Screen 1) */
export const RETURN_METHOD_TITLE = 'How would you like to return it?';
export const RETURN_METHOD_SUBTITLE = 'Please choose from these return methods:';

export const RETURN_METHOD_SHIP = 'ship';
export const RETURN_METHOD_STORE = 'store';

export const RETURN_METHOD_SHIP_LABEL = 'Ship It Back';
export const RETURN_METHOD_SHIP_DESCRIPTION = 'Send your package back to us.';
export const RETURN_METHOD_STORE_LABEL = 'Return in Store';
export const RETURN_METHOD_STORE_DESCRIPTION = 'Return in person for a fast refund.';

/* In-store eligibility question shown when "Return in Store" is selected */
export const RETURN_IN_STORE_ELIGIBILITY_QUESTION =
    'Does your item fit within a 24" x 14" x 10" box or a 33" x 32" polybag?';

/* Return in Store go-to-store screen (shown after Return in Store + eligible/Yes) */
export const RETURN_GUIDANCE_STORE_TITLE = 'Return in Store';
export const RETURN_GUIDANCE_STORE_SUBTITLE = 'No online return request is required.';
export const RETURN_GUIDANCE_STORE_MESSAGE =
    'To return your item in store, please visit your preferred store location and bring the item with you.';
export const RETURN_GUIDANCE_STORE_FIND_STORE = 'Find a Store Near You';

/*
 * Shown when the customer chooses to ship the item back (Scenario 3 & 4).
 * Rendered inside an informational (blue) alert; the leading "Important:" and
 * "Ship It Back," segments are bold in the design.
 */
export const RETURN_SHIP_BACK_WARNING_LEAD = 'Important:';
export const RETURN_SHIP_BACK_WARNING_MIDDLE = ' If you choose ';
export const RETURN_SHIP_BACK_WARNING_METHOD = 'Ship It Back,';
export const RETURN_SHIP_BACK_WARNING_TAIL =
    ' the item will no longer be eligible for an in-store return. Please do not bring the item to a store.';
/* Plain-text version (used on the final confirmation page / non-rich contexts) */
export const RETURN_SHIP_BACK_WARNING =
    'If you choose to ship this item back, it will no longer be eligible for an in-store return. Please do not bring the item to a store.';

/*
 * Shown on the Return Request Submitted (review confirmation) page.
 * The leading "Important:" and the "Ship It Back" segment are bold.
 */
export const RETURN_REVIEW_SHIP_BACK_WARNING_LEAD = 'Important:';
export const RETURN_REVIEW_SHIP_BACK_WARNING_MIDDLE = ' Your return has been set up for ';
export const RETURN_REVIEW_SHIP_BACK_WARNING_METHOD = 'Ship It Back';
export const RETURN_REVIEW_SHIP_BACK_WARNING_TAIL =
    '. This item is no longer eligible for an in-store return. Please do not bring the item to a store.';

/*
 * Shown in the Return in Store card when the item does NOT meet the size requirements.
 * The "Ship It Back" segment is bold in the design.
 */
export const RETURN_IN_STORE_NOT_ELIGIBLE_WARNING_LEAD =
    'Sorry, you can’t return your item in store. For items larger then these dimensions, please select the ';
export const RETURN_IN_STORE_NOT_ELIGIBLE_WARNING_METHOD = 'Ship It Back';
export const RETURN_IN_STORE_NOT_ELIGIBLE_WARNING_TAIL = ' option.';
